import { generateIconComponent } from './icons.utils';

export const FacebookIcon = generateIconComponent({
    name: 'FacebookIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M18.0117 13.5L18.6783 9.15656H14.5106V6.33797C14.5106 5.14969 15.0928 3.99141 16.9594 3.99141H18.8541V0.293438C18.8541 0.293438 17.1347 0 15.4908 0C12.0586 0 9.81516 2.08031 9.81516 5.84625V9.15656H6V13.5H9.81516V24H14.5106V13.5H18.0117Z" />
    ),
});
